const getCategory = ({ catState }) =>
  catState.category;

export {
  getCategory
};
